import type { Key } from "react";
import type {
  ICreateMode,
  IChangingMode,
  IOfferFieldName,
  IOfferFieldNameRule,
} from "../../../../lib/types";
import { OFFER_STATUSES, OFFER_TYPES } from "../../../../store/slices/offering/const";

// !При добавлении версии, в качестве статус предложения берется статус версии - основания

const { PREPARE, SUSPENDED, ACTIVE, ARCHIVE, ARCHIVE_PROLONGABLE } = OFFER_STATUSES;

// Доступность полей к редактированию по схеме: имя поля => режим измененения => статус предложения => правило доступности
export const isFieldAvailable = (params: {
  fieldName: IOfferFieldName;
  viewMode: ICreateMode | IChangingMode;
  offeringStatusId: number;
  options?: { [key: Key]: any };
}): boolean => {
  const { fieldName, viewMode, offeringStatusId, options } = params;
  const fieldNameRules: IOfferFieldNameRule = {
    extName: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
        [ARCHIVE_PROLONGABLE]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
        [ARCHIVE_PROLONGABLE]: true,
      },
    },
    name: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
      },
    },
    periodAlignmentId: {
      create: {
        [PREPARE]: options?.tariffModelId !== 2,
      },
      edit: {
        [PREPARE]: options?.tariffModelId !== 2,
        [SUSPENDED]: options?.tariffModelId !== 2,
      },
      add: {
        [PREPARE]: options?.tariffModelId !== 2,
        [SUSPENDED]: options?.tariffModelId !== 2,
      },
    },
    tariffModelId: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
    offeringStatusId: {
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE_PROLONGABLE]: true,
      },
    },
    isStandalone: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
      },
    },
    prolongTypeId: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
        [ARCHIVE_PROLONGABLE]: true,
      },
    },
    lifespanPeriodId: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
    lifespanPeriodQty: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
    offeringTypeId: {
      create: {
        [PREPARE]: true,
      },
    },
    agreementId: {
      create: {
        [PREPARE]: options?.offeringTypeId === OFFER_TYPES.PERSONAL,
      },
      edit: {
        [PREPARE]: options?.offeringTypeId === OFFER_TYPES.PERSONAL,
      },
      add: {
        [PREPARE]: options?.offeringTypeId === OFFER_TYPES.PERSONAL,
      },
    },
    fromDate: {
      create: {
        [PREPARE]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
        [ARCHIVE_PROLONGABLE]: true,
      },
    },
    toDate: {
      create: {
        [PREPARE]: true,
      },
      close: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
      },
    },
    bundleTypeId: {
      create: {
        [PREPARE]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
  };
  return Boolean(fieldNameRules[fieldName]?.[viewMode]?.[offeringStatusId]);
};
